import { render, staticRenderFns } from "./SectorCell.vue?vue&type=template&id=2c397014"
import script from "./SectorCell.vue?vue&type=script&lang=js"
export * from "./SectorCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports